// import Cookies from 'js-cookie';
import { CartProduct } from './cart_item';
import { SideCart } from '../views/cart-side';

var Cart = Backbone.Model.extend({
    defaults: {
        'count': 0,
        'products' : null,
        'samples' : null,
        'messages' : null
    },
    initialize: function(){
        this.sideCart = null;

        this.cartCookieName = 'grc_cart';
        _.bindAll( 
            this,
            'addProductToCart',
            'updateCartProduct',
            'getCartProduct',
            'updateCount',
            'loadCart',
            'updateCart',
            'addSample',
            'sendMessage',
            'clearCart',
            'showSideCart',
            'logCart'
        );
        this.loaded = false;
        var products = new Backbone.Collection();
        this.set({ 'products': products });

        var samples = new Backbone.Collection();
        this.set({ 'samples': samples });


        var messages = new Backbone.Collection();
        this.set({ 'messages': messages });

        this.loadCart();

        this.listenTo( products, 'change add remove reset', this.updateCart );
        this.listenTo( samples, 'change add remove reset', this.updateCart );

        this.updateCount();
    },
    showSideCart: function(){
        if ( ! this.sideCart ) {
            const sideCart = new SideCart({ model: this });
            this.sideCart = sideCart;
            this.sideCart.render();
        }
        this.sideCart.showFlyout();
    },
    clearCart: function(){
        var products = this.get( 'products' );
        var samples = this.get( 'products' );
        this.stopListening( products, 'change add remove reset', this.updateCart );
        this.stopListening( samples, 'change add remove reset', this.updateCart );
        samples.reset();
        products.reset();
        var data = {};
        data.products = products.toJSON();
        data.samples = samples.toJSON();
        var cart_str = JSON.stringify( data );
        // Cookies.remove( this.cartCookieName );
        // console.log(cart_str);
		localStorage.setItem( this.cartCookieName, cart_str );
        this.set({'count' : 0 });
    },
    loadCart: function(){
        // get the cart cookie, parse it to JSON, and add the information to the model settings.
        var cartStr = localStorage.getItem( this.cartCookieName );
        if ( typeof cartStr !== 'undefined' && ! _.isNull( cartStr ) ) {
            var cartData = JSON.parse( cartStr );
            // console.log( cartData );
            
            // console.log( cartData );

            if ( !_.isEmpty( cartData.products ) ) {
                _.each( cartData.products, this.addProductToCart );
            }
            if ( !_.isEmpty( cartData.samples ) ) {
                _.each( cartData.samples, this.addSample );
            }
        } 
        this.loaded = true;
    },
    addProductToCart:function( settings ){
        // console.log( settings );
        var products = this.get( 'products' );
        var prod = new CartProduct( settings );
        products.add( prod );
        if ( this.loaded ) {
            this.sendMessage( 'Product Added' );
            this.trigger( 'product_added' );
            this.showSideCart();
        }
    },
    updateCartProduct:function( i, settings ){
        // console.log( settings );
        var prod = this.get('products').findWhere({ 'cart_id' : i });
        if ( prod ) {
            prod.set(settings);
            this.showSideCart();
            this.sendMessage( 'Product Updated' );
        }
    },
    getCartProduct: function( i ){
        var prod = this.get('products').findWhere({ 'cart_id' : i });
        return prod;
    },
    updateCart: function(){
        var data = {};
        data.products = this.get( 'products' ).toJSON();
        data.samples = this.get( 'samples' ).toJSON();
        var cart_str = JSON.stringify( data );
        // Cookies.remove( this.cartCookieName );
        // console.log(cart_str);
		localStorage.setItem( this.cartCookieName, cart_str );
        this.updateCount();
        // this.sendMessage( 'Cart Saved' );
        
    },
    updateCount: function(){
        var products = this.get( 'products' );
        var samples = this.get( 'samples' );
        var count = products.length + samples.length;
        
        this.set({'count' : count });
        this.trigger( 'update_cart' )
    },
    addSample: function( item ) {
        var samples = this.get('samples');
        var response = {
            'message' : 'Add Sample API Call',
            'success' : true
        };
        var sample = samples.findWhere({ 'post_id' : item.post_id });
        if ( _.isEmpty( sample ) ) {
            sample = new Backbone.Model(item);
            samples.add( sample );
            response.message = 'Sample ' + item.name + ' Added to Cart';

            if ( this.loaded ) {
                this.trigger( 'sample_added' );
                this.sendMessage( response.message );
            }
        } else {
            response.message = 'Sample ' + item.name + ' Already Present';
            response.success = false;
        }
        return response;
    },
    sendMessage: function( message ) {
        var messageModel = new Backbone.Model( { 'message' :message  });
        this.get( 'messages' ).add( messageModel );

        this.trigger( 'message' );
    },
    logCart: function(){
        console.log( 'count', this.get( 'count' ) ); // eslint-disable-line no-console
        console.log( 'products', this.get( 'products' ).toJSON() ); // eslint-disable-line no-console
        console.log( 'samples', this.get( 'samples' ).toJSON() ); // eslint-disable-line no-console
        console.log( 'messages', this.get( 'messages' ).toJSON() ); // eslint-disable-line no-console
    }
});
export {Cart};